import { useState } from "react";
import { Link } from "react-router-dom";
import { decodeHomeDepotPrice, parsePrice, type HDPriceCode } from "../../utils/toolCalculators";
import { toolInputClass, toolLabelClass } from "./toolUi";

const money = (n: number) => n.toLocaleString("en-US", { style: "currency", currency: "USD" });

const TONE: Record<HDPriceCode, string> = {
  penny: "border-emerald-300 bg-emerald-50 text-emerald-900",
  final: "border-amber-300 bg-amber-50 text-amber-900",
  early: "border-sky-300 bg-sky-50 text-sky-900",
  regular: "border-slate-200 bg-white text-slate-800",
};

const EXAMPLES = ["24.03", "48.06", "0.01", "19.97"];

export default function HDPriceDecoderTool() {
  const [price, setPrice] = useState("");
  const [original, setOriginal] = useState("");
  const parsed = parsePrice(price);
  const parsedOriginal = parsePrice(original);
  const result = parsed !== null && parsed > 0 ? decodeHomeDepotPrice(parsed, parsedOriginal) : null;

  return (
    <div>
      <div className="grid gap-4 sm:grid-cols-2">
        <label>
          <span className={toolLabelClass}>Price on the tag</span>
          <input className={toolInputClass} inputMode="decimal" placeholder="e.g. 24.03" value={price} onChange={(e) => setPrice(e.target.value)} aria-label="Clearance price" />
        </label>
        <label>
          <span className={toolLabelClass}>Original price (optional)</span>
          <input className={toolInputClass} inputMode="decimal" placeholder="e.g. 49.98" value={original} onChange={(e) => setOriginal(e.target.value)} aria-label="Original price" />
        </label>
      </div>
      <div className="mt-3 flex flex-wrap gap-2 text-sm">
        <span className="text-slate-500">Try:</span>
        {EXAMPLES.map((ex) => (
          <button key={ex} type="button" onClick={() => setPrice(ex)} className="rounded-full border border-slate-300 bg-white px-3 py-0.5 font-medium hover:border-violet-400">
            ${ex}
          </button>
        ))}
      </div>

      {price && parsed === null && <p className="mt-4 text-sm text-red-600">Enter a price like 24.03.</p>}

      {result && (
        <div className={`mt-5 rounded-xl border p-4 sm:p-5 ${TONE[result.code]}`} role="status">
          <p className="text-xs font-semibold uppercase tracking-wide opacity-70">Ends in {result.cents}</p>
          <p className="mt-1 text-2xl font-extrabold">{result.headline}</p>
          <p className="mt-2 leading-relaxed">{result.detail}</p>
          {result.savings !== undefined && (
            <p className="mt-3 font-semibold">
              {money(result.savings)} off ({result.percentOff}% below {money(parsedOriginal!)})
            </p>
          )}
          {(result.code === "final" || result.code === "early") && (
            <p className="mt-3 text-sm">
              Got the SKU? <Link to="/tools/home-depot-penny-checker" className="font-semibold underline">Check it for penny signals</Link>.
            </p>
          )}
        </div>
      )}
    </div>
  );
}
